var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#F98883"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5318_12460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 12.6875C18.375 13.9426 17.9676 15.102 17.2812 16.0426L20.743 19.507C21.0848 19.8488 21.0848 20.4039 20.743 20.7457C20.4012 21.0875 19.8461 21.0875 19.5043 20.7457L16.0426 17.2812C15.102 17.9703 13.9426 18.375 12.6875 18.375C9.5457 18.375 7 15.8293 7 12.6875C7 9.5457 9.5457 7 12.6875 7C15.8293 7 18.375 9.5457 18.375 12.6875ZM9.84375 12.9062V14.6562C9.84375 15.0199 10.1363 15.3125 10.5 15.3125C10.8637 15.3125 11.1562 15.0199 11.1562 14.6562V12.9062C11.1562 12.5426 10.8637 12.25 10.5 12.25C10.1363 12.25 9.84375 12.5426 9.84375 12.9062ZM12.0312 10.2812V14.6562C12.0312 15.0199 12.3238 15.3125 12.6875 15.3125C13.0512 15.3125 13.3438 15.0199 13.3438 14.6562V10.2812C13.3438 9.91758 13.0512 9.625 12.6875 9.625C12.3238 9.625 12.0312 9.91758 12.0312 10.2812ZM14.2188 12.0312V14.6562C14.2188 15.0199 14.5113 15.3125 14.875 15.3125C15.2387 15.3125 15.5312 15.0199 15.5312 14.6562V12.0312C15.5312 11.6676 15.2387 11.375 14.875 11.375C14.5113 11.375 14.2188 11.6676 14.2188 12.0312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5318_12460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.6fb4eadf255932e77ecf222fcc25ff48.svg";
export { ForwardRef as ReactComponent };